var _mask, _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYandexDialogs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 19,
    height: 20
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1382 2.507L4.81042 5.64092C3.68875 6.30075 3 7.50492 3 8.80625V15.1937C3 16.4952 3.68875 17.6992 4.81042 18.3591L10.1382 21.493C10.708 21.8282 11.3457 21.9972 11.9839 22H12.0163C12.6545 21.9972 13.2922 21.8282 13.862 21.493L19.1898 18.3591C20.3115 17.6992 21.0002 16.4952 21.0002 15.1937V8.80625C21.0002 7.50492 20.3115 6.30075 19.1898 5.64092L13.862 2.507C13.2874 2.169 12.6437 2 12.0001 2C11.3565 2 10.7128 2.169 10.1382 2.507Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1382 2.507L4.81042 5.64092C3.68875 6.30075 3 7.50492 3 8.80625V15.1937C3 16.4952 3.68875 17.6992 4.81042 18.3591L10.1382 21.493C10.708 21.8282 11.3457 21.9972 11.9839 22H12.0163C12.6545 21.9972 13.2922 21.8282 13.862 21.493L19.1898 18.3591C20.3115 17.6992 21.0002 16.4952 21.0002 15.1937V8.80625C21.0002 7.50492 20.3115 6.30075 19.1898 5.64092L13.862 2.507C13.2874 2.169 12.6437 2 12.0001 2C11.3565 2 10.7128 2.169 10.1382 2.507Z",
    fill: "url(#paint0_linear)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0781 9.70736C19.0779 9.66603 19.0682 9.6242 19.0461 9.5857C18.9778 9.46728 18.8267 9.42695 18.7083 9.49503V9.49495L14.2464 12.0679C13.2756 12.7124 12.6312 13.7869 12.6304 14.8059V18.1774C12.6303 18.3471 12.689 18.5062 12.7681 18.6434C12.9295 18.9234 13.2315 19.1122 13.5771 19.1126C13.7898 19.1124 13.9239 19.0745 14.1287 18.9564L17.036 17.2791C18.7879 16.2814 19.0165 15.9195 19.0743 14.0573L19.0792 9.70803L19.0781 9.70736ZM9.17148 11.2687L6.30998 9.6152C6.16589 9.53195 6.00864 9.49253 5.85331 9.49253C5.53648 9.49253 5.22823 9.65653 5.05873 9.94986C4.95464 10.1306 4.92114 10.2631 4.92114 10.4949V14.0242C4.92939 15.7936 5.17131 16.1741 6.65948 17.0949L10.3504 19.2291L10.3514 19.2285C10.3867 19.2485 10.427 19.2609 10.4704 19.2609C10.6044 19.2609 10.7126 19.1524 10.7129 19.0184V19.0183L10.7131 13.9684C10.6413 12.8281 10.0364 11.7684 9.17148 11.2687ZM17.0052 8.3477C17.1523 8.26186 17.2673 8.1422 17.3462 8.0042C17.5072 7.7227 17.5181 7.36536 17.3437 7.06561C17.2361 6.88128 17.1354 6.7842 16.9294 6.66636L14.0287 4.99478C12.2781 3.9807 11.8301 3.97853 10.1871 4.8702L6.41098 7.05186V7.05311C6.37523 7.07428 6.34381 7.10378 6.32173 7.14245C6.25356 7.26145 6.29506 7.41286 6.41389 7.48111L10.9001 10.0479C11.9496 10.5636 13.1983 10.5646 14.0819 10.0499L17.0052 8.3477Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 2.85269,
    y1: 12.4794,
    x2: 21.1552,
    y2: 11.7024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8200FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BCC3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYandexDialogs);
export default __webpack_public_path__ + "static/media/yandexDialogs.2dd78084.svg";
export { ForwardRef as ReactComponent };